import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const ranked = [...comics]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);

  const rankMedals = ['ri-medal-fill', 'ri-medal-fill', 'ri-medal-fill'];
  const rankColors = [
    'text-accent-500',
    'text-secondary-400',
    'text-primary-400',
  ];

  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">评分最高的人气作品</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left - Top 3 highlight */}
          <div className="flex gap-4">
            {ranked.slice(0, 3).map((comic, index) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex-1 group cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 排行榜第${index + 1}名`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center bg-foreground-900/80 rounded-br-lg">
                    <i className={`${rankMedals[index]} text-lg ${rankColors[index]}`}></i>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                    <span className="text-white text-xs font-medium block truncate">{comic.title}</span>
                    <span className="text-white/70 text-[10px]">{comic.rating}分</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Right - Rank 4-8 list */}
          <div className="space-y-2">
            {ranked.slice(3, 8).map((comic, index) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors group cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-sm font-bold text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors flex-shrink-0">
                  {index + 4}
                </span>
                <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-0.5 truncate">{comic.author}</p>
                </div>
                <div className="flex items-center gap-1 text-accent-500 text-sm flex-shrink-0">
                  <i className="ri-star-fill text-xs"></i>
                  <span className="font-medium">{comic.rating}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}